export default [
    {
      // py根组件
      path: "/yt",
      name: "ytDefalut",
      component: () => import("@/layout/yt/index.vue"),
      meta: {
        unrequireLogin: true, // true 为组件不需要登录
      },
      redirect: {
        title: "雁塔教育云",
        name: "ytIndex",
      },
      children: [
        {
          path: "/yt/home", 
          name: "yt_home",
          component: () => import("../views/ytIndex/home.vue"),
          meta: {
            unrequireLogin: true,
            title: "雁塔区首页",
            name:"ytHome",
          },
        },
        { // 学校列表
          path: "/yt/list", 
          name: "yt_list",
          component: () => import("../views/ytIndex/list.vue"),
          meta: {
            unrequireLogin: true,
            title: "学校列表",
            name:"ytList",
          },
        },
        { // 学校列表
          path: "/yt/detail", 
          name: "yt_detail",
          component: () => import("../views/ytIndex/detail.vue"),
          meta: {
            unrequireLogin: true,
            title: "学校详情",
            name:"ytDetail",
          },
        },
        { // 服务地图
          path: "/yt/map", 
          name: "ytMap",
          component: () => import("../views/ytIndex/map.vue"),
          meta: {
            unrequireLogin: true,
            title: "服务地图",
            name:"ytMap",
          },
        },
      ],
    },
  ];